export default __webpack_public_path__ + "static/media/pp-logo-dark.72e7b730.svg";